export default __webpack_public_path__ + "static/media/link-broken_darkGray1.3bfa24a1.svg";